<template>
  <div class="email-clickable">
    <div v-if="domainClickable" class="email">
      <span>{{ `${domainClickable[0]}@` }}</span>
      <a
        :href="`https://${domainClickable[1]}`"
        target="_blank"
        class="link domain"
        >{{ domainClickable[1] }}</a
      >
    </div>
    <span v-else>{{ email }}</span>
    <DuplicateIcon class="copy-icon" @click.stop="copyEmail(email)" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from "vue";

import { copy } from "@/clipboard";
import DuplicateIcon from "@/components/icons/DuplicateIcon.vue";
import * as inject from "@/components/inject";

export default defineComponent({
  components: { DuplicateIcon },
  props: {
    email: { type: String, required: true },
  },
  setup(props) {
    const { email } = toRefs(props);
    const controller = inject.controller();
    const genericDomains = new Set([
      "gmail",
      "googlemail",
      "yahoo",
      "hotmail",
      "live",
      "aol",
      "msn",
      "outlook",
      "icloud",
      "protonmail",
    ]);
    const domainClickable = computed(() => {
      let parts = email.value.split("@");
      if (parts.length == 2) {
        if (!genericDomains.has(parts[1].split(".")[0])) {
          return [parts[0], parts[1]];
        }
      }
      return undefined;
    });
    const copyEmail = async (email: string) => {
      await copy(email);
      controller.notifications.notify(`${email} copied to clipboard`);
    };
    return { copyEmail, domainClickable };
  },
});
</script>

<style scoped lang="scss">
.email-clickable {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
  .email {
    a {
      text-decoration: none;
      @include transition(all 100ms ease-in);
      @include themed() {
        color: t($primary);
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .copy-icon {
    display: none;
    height: 12px;
    width: 12px;
    :deep(path.fill) {
      @include themed() {
        fill: t($grey-40);
      }
    }
    &:hover {
      :deep(path.fill) {
        @include themed() {
          fill: t($grey-80);
        }
      }
    }
  }
  &:hover .copy-icon {
    display: flex;
  }
}
</style>
